/** Current terms version — keep in sync with app/core/terms.py */
export const CURRENT_TERMS_VERSION = "2026-08-31";

/**
 * Planned paid launch messaging (beta banner / landing).
 * Should match backend PAID_PLANS_EXPECTED setting.
 * 
 * To update: change backend .env → PAID_PLANS_EXPECTED=... → rebuild frontend
 */
export const BETA_PAID_PLANS_EXPECTED = "Q4 2026";
